import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import React from 'react';

const CartStructuredData = ({ url, title }) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            item: {
              '@id': url,
              name: title,
            },
          },
        ],
      })}
    </script>
  </Helmet>
);

CartStructuredData.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default CartStructuredData;
